
<form [formGroup] = "impactedAssetForm">

<div class="contents">
    <div class="impacted_assets">



      <div class="btn_hold">
        <h2 class="heading" style="width:80%;">Impacted Asset</h2>

        <button class="default_secondary-btn" (click)="onPopUpDisplay(landTitles)">Add Reference Asset</button>
        <button class="default_secondary-btn" (click)="addNonReferenceAsset()">Add Non Reference Asset</button>

        <div class="toggle_view" style="position: unset">
            <mat-button-toggle-group
          name="fontStyle"
          aria-label="Font Style"
          color="accent"
          class="m-3"

          >
          <mat-button-toggle value="list" color="accent" (click)="onList()"
            ><mat-icon class="example-tab-icon"
              >list</mat-icon
            ></mat-button-toggle
          >
          <mat-button-toggle value="grid" (click)="onGrid()"
            ><mat-icon class="example-tab-icon"
              >view_module</mat-icon
            ></mat-button-toggle
          >
          </mat-button-toggle-group>
          </div>


      </div>



      <div class="actual_display" *ngIf="listView">
        <div class="impacted_asset-table">
          <div class="the_head">
            <span class="head_item">S/N</span>
            <span class="head_item">Asset Name</span>
            <span class="head_item">State</span>
            <span class="head_item">Lga</span>
            <span class="head_item">Community</span>
            <span class="head_item">Remark</span>
            <span class="head_item">Delete</span>
          </div>

          <div class="row" formArrayName="ImpactedAssets" style="padding:0; display: block; flex-wrap: unset; margin:0;">

          <div class="the_row" *ngFor="let impactassetitem of impactedAssetForm.get('ImpactedAssets')['controls']; index as i" [formGroupName]="i"
          style="cursor: pointer;"

            aria-label="Button that displays a tooltip when focused or hovered over">
            <span class="row_data">{{i + 1}}</span>
            <span class="row_data"> <input type="text" style="width:95%;" class="default_input" formControlName="LandName"></span>
            <span class="row_data"><input type="text" style="width:95%;" class="default_input" formControlName="StateName"></span>
            <span class="row_data"> <input type="text" style="width:95%;" class="default_input" formControlName="LgaName"></span>
            <span class="row_data"> <input type="text" style="width:95%;" class="default_input" formControlName="CommunityName"></span>
            <span class="row_data" style="width:100%;"><input type="text" style="width:95%;" class="default_input" formControlName="Remarks"></span>
            <span class="row_data" (click)="$event.stopImmediatePropagation()">
              <button class="delete_icon trash" style="background:none; border:none; outline: none;" (click)="deleteImpactedAsset(impactassetitem.value, i)">
              <em class="ti-trash"> </em> 
            </button>
            </span>
          </div>
          </div>

        </div>
      </div>


    </div>

    <div class="btn_holder" *ngIf="listView">
        <button  class="default_primary-button"  (click)="onSubmit()" >

            Save  &rarr;

        </button>
       </div>




     <div class="entry_values" formArrayName="ImpactedAssets" *ngIf="gridView">
        <div class="entry" *ngFor="let impactassetitem of impactedAssetForm.get('ImpactedAssets')['controls']; index as i" [formGroupName]="i">
          <h1 class="section_name">
            <em class="ti-image"></em> 
            <span class="name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input"  placeholder="Land Name" formControlName="LandName"></span>
            <em class="ti-trash"  (click)="deleteImpactedAsset(impactassetitem.value, i)"></em> 
          </h1>

          <div class="location">
            <p class="other_item">State Name: <span class="file_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="StateName"></span></p>
            <p class="other_item">Lga Name: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="LgaName"></span></p>
            <p class="other_item">Community Name: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="CommunityName"></span></p>
            <p class="other_item">Remarks: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="Remarks"></span></p>

          </div>
        </div>
        <div class="btn_holder">
            <button  class="default_primary-button"  (click)="onSubmit()" >

                Save  &rarr;

            </button>
         </div>
      </div>


    </div>
    <!-- <pre>{{impactedAssetForm.value | json}}</pre> -->
  </form>
